module.exports = __webpack_public_path__ + "static/media/swapBg.a45096e7.png";